export const isNonNegativeNumber = (value?: number): boolean =>
  isNumber(value) && value >= 0;

export const isNumber = (value?: number): value is number =>
  typeof value === 'number';

export const isNonDecimalNumber = (value: number) => value % 1 === 0;

export const numericRangeClamp = (
  valueToCheck: string | undefined,
  min: number | null,
  max: number | null,
): boolean => {
  if (!valueToCheck) {
    return true;
  }

  if (!parseInt(valueToCheck) && valueToCheck !== '0') {
    return false;
  }

  const newNumericValue = valueToCheck === '0' ? 0 : parseInt(valueToCheck);

  if (min !== null && newNumericValue < min) {
    return false;
  }

  if (max !== null && newNumericValue > max) {
    return false;
  }

  return true;
};
